import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      id: "about",
      title: "1. About PolicySaath",
      content: "PolicySaath is a digital platform designed to help insurance agents manage customer data, policies, renewals, and related activities more efficiently. We do not sell insurance directly and do not act as an insurer."
    },
    {
      id: "eligibility",
      title: "2. Eligibility",
      content: "You must be at least 18 years old to use our services. By using PolicySaath, you confirm that the information you provide is accurate and lawful."
    },
    {
      id: "responsibilities",
      title: "3. User Responsibilities",
      list: [
        "You are responsible for maintaining the confidentiality of your login credentials",
        "You agree not to misuse the platform or attempt unauthorized access",
        "You are responsible for the data you upload, store, or manage using the software",
        "You must comply with all applicable laws and IRDAI guidelines"
      ]
    },
    {
      id: "usage",
      title: "4. Service Usage",
      content: "PolicySaath provides software tools only. We do not guarantee business results, leads, commissions, or sales growth. Features may be updated, modified, or discontinued without prior notice."
    },
    {
      id: "payments",
      title: "5. Payments and Subscriptions",
      list: [
        "Paid plans are billed as per the selected pricing",
        "Fees once paid are non refundable unless stated otherwise",
        "Failure to pay may result in account suspension or termination"
      ]
    },
    {
      id: "property",
      title: "6. Intellectual Property",
      content: "All content, logos, software, and designs on policysaath.com are owned by PolicySaath. You may not copy, modify, or redistribute any part without written permission."
    },
    {
      id: "termination",
      title: "7. Account Suspension or Termination",
      content: "We reserve the right to suspend or terminate accounts found violating these terms, misusing the platform, or engaging in unlawful activities."
    },
    {
      id: "liability",
      title: "8. Limitation of Liability",
      content: "PolicySaath is not responsible for data loss, business loss, or indirect damages arising from the use of our platform."
    },
    {
      id: "changes",
      title: "9. Changes to Terms",
      content: "We may update these terms at any time. Continued use of the platform means you accept the revised terms."
    }
  ];

  return (
    <>
    <Header/>
    <div className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="container mt-5">
          <h1 className='pt-5'>Terms & Conditions</h1>
          <p className="last-updated">Effective Date: October 2023</p>
        </div>
        <div className="wave-bg">
          <svg viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,165.3C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content-section">
        <div className="container">
          <div className="content-wrapper">
            <div className="intro-card">
              <p>Welcome to <strong>PolicySaath</strong>. By accessing or using policysaath.com and its services, you agree to follow these Terms of Service. Please read them carefully.</p>
            </div>

            <div className="terms-grid">
              {sections.map((section) => (
                <div key={section.id} className="terms-card">
                  <h3>{section.title}</h3>
                  {section.content && <p>{section.content}</p>}
                  {section.list && (
                    <ul>
                      {section.list.map((item, index) => (
                        <li key={index}><i className="bi bi-check2-circle"></i> {item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              {/* Contact Card */}
              <div className="terms-card contact-card">
                <h3>10. Contact</h3>
                <p>For any questions, feel free to reach out to our support team:</p>
                <div className="contact-methods">
                  <a href="mailto:policysaath@gmail.com" className="contact-item">
                    <i className="bi bi-envelope-fill"></i>
                    <span>policysaath@gmail.com</span>
                  </a>
                  <a href="tel:+919136356555" className="contact-item">
                    <i className="bi bi-telephone-fill"></i>
                    <span>+91-9136356555</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
    </>
  );
};

export default TermsConditions;